module.exports = __webpack_public_path__ + "static/media/secondBlockRetail.511951b6.jpg";